import Layout from "components/layout";
import Encounter from "pages/encounter";
import ErrorPage from "pages/errorPage";
import { createBrowserRouter } from "react-router-dom";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Layout />,
        errorElement: <ErrorPage />,
        children: [
            {
                index: true,
                element: <Encounter />
            }
        ]
    }
]);

export default router;
